<template>
  <v-container id="grupomodificadores" tag="section">
    <base-v-component heading="Grupo Modificadores del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click="goAdd()"
          >Añadir Grupo</v-btn
        >
        <v-text-field
          class="ml-4"
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        />
        <v-spacer />
        <v-btn color="success" @click="getGrupos()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :search="search"
        :items="gruposModificadores"
        :loading="loading"
      >
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-btn
            @click="goEdit(item)"
            class="px-2 ml-1"
            color="secondary"
            min-width="0"
            small
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click="deleteItem(item)"
            class="px-2 ml-1"
            color="red"
            min-width="0"
            small
            :loading="loadingBorrar"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";

export default {
  data() {
    return {
      loading: false,
      loadingBorrar: false,
      search: "",
      headers: [
        {
          text: "Nombre",
          value: "nombre",
        },
        {
          text: "Desc interna",
          value: "descripcion",
        },
        {
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      gruposModificadoresBruto: (state) => state.productos.gruposModificadores,
    }),
    ...mapGetters({
      negocio: "app/negocioGestObj",
    }),
    gruposModificadores() {
      return this.gruposModificadoresBruto.map((g) => {
        return {
          ...g,
          nombre: g.nombre,
        };
      });
    },
  },
  methods: {
    deleteItem(item) {
      var _vm = this;
      this.$confirm(
        "¿Desea eliminar este grupo? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      ).then((res) => {
        if (res) {
          _vm.loadingBorrar = true;
          return this.$store
            .dispatch("productos/deleteGrupoModificador", item)
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Grupo borrado con éxito",
              });
              return _vm.getGrupos();
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al borrar el grupo " + error,
              });
            })
            .finally(() => {
              _vm.loadingBorrar = false;
            });
        }
      });
    },
    getGrupos() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("productos/getGruposModificadores")
        .finally(() => {
          _vm.loading = false;
        });
    },
    goAdd() {
      let str =
        "/admin/gest/" + this.negocio.id + "/almacen/gruposmodificadores/form";
      this.$router.push(str);
    },
    goEdit(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/almacen/gruposmodificadores/form/" +
        item.id;
      this.$router.push(str);
    },
  },
  mounted() {
    this.getGrupos();
  },
};
</script>

<style>
</style>